export default __webpack_public_path__ + "static/media/1-GLOBALE.a7fd7d71.pdf";